import React from "react";

export default function Club({ settings, handleChange, disabled = false }) {
  const inputClass =
    "w-full px-3 py-2 rounded-xl border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 text-sm focus:outline-none focus:ring-2 focus:ring-primary/40";

  const labelClass = "block text-xs font-extrabold uppercase text-gray-600 dark:text-gray-300";

  return (
    <div className="grid gap-4 md:grid-cols-2">
      <div>
        <label className={labelClass}>Nom</label>
        <input
          type="text"
          name="nom_club"
          value={settings.nom_club || ""}
          onChange={handleChange}
          disabled={disabled}
          className={inputClass}
          placeholder="Entrez le nom du club"
        />
      </div>

      <div>
        <label className={labelClass}>Nom court</label>
        <input
          type="text"
          name="shortname_club"
          value={settings.shortname_club || ""}
          onChange={handleChange}
          disabled={disabled}
          className={inputClass}
          placeholder="Ex: US Bouscat Judo"
        />
      </div>

      <div>
        <label className={labelClass}>Responsable</label>
        <input
          type="text"
          name="responsable_club"
          value={settings.responsable_club || ""}
          onChange={handleChange}
          disabled={disabled}
          className={inputClass}
          placeholder="Nom du responsable"
        />
      </div>

      <div>
        <label className={labelClass}>SIRET</label>
        <input
          type="text"
          name="siret_club"
          value={settings.siret_club || ""}
          onChange={handleChange}
          disabled={disabled}
          className={inputClass}
          placeholder="Entrez le SIRET"
        />
      </div>
    </div>
  );
}
